// extracted by mini-css-extract-plugin
module.exports = {"module":"complex-floor_module__Tqj6t","flats":"complex-floor_flats__3k98O"};